/**
 * Synthesized oval sink cutout for a PROCEDURAL basin (no GLB, so no measured
 * `sink-cutout`). Countertop.jsx CSG cuts this profile out of the slab,
 * applying its own 1" radial inset — so the resulting hole is ~1" smaller
 * than the basin opening, matching an undermount installation where the
 * counter overhangs the rim.
 *
 * Extracted from `assembleVanity` so the manual cabinet-run engine's vanity
 * basin (`buildVanitySink.js`) synthesizes the identical profile — a second
 * inline copy is how the two would drift.
 *
 * Coordinates are in INCHES relative to the sink centre (the renderer's
 * convention for cutout profiles).
 */

const { INCHES_TO_METERS } = require('./constants');

function synthesizeOvalSinkCutout(widthMeters, depthMeters) {
  const halfW = widthMeters / INCHES_TO_METERS / 2;
  const halfD = depthMeters / INCHES_TO_METERS / 2;
  const N = 24;
  const points = [];
  for (let p = 0; p < N; p++) {
    const a = (p / N) * Math.PI * 2;
    points.push({
      x: Math.cos(a) * halfW,
      z: Math.sin(a) * halfD,
    });
  }
  return {
    points,
    metadata: {
      bounds: { minX: -halfW, maxX: halfW, minZ: -halfD, maxZ: halfD },
      vertexCount: N,
      synthesized: true,
    },
  };
}

module.exports = { synthesizeOvalSinkCutout };
